export function CopyIcon({ color }: { color?: string }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="none">
      <path
        d="M11.9 13.13H5.79a1.97 1.97 0 0 1-1.97-1.97V5.03a1.97 1.97 0 0 1 1.97-1.97h6.13a1.97 1.97 0 0 1 1.97 1.97v6.13a1.97 1.97 0 0 1-1.97 1.97"
        fill={color || "currentColor"}
      />
      <path
        d="M5.13 2.19h6.44A2 2 0 0 0 9.72.88H3.59a1.97 1.97 0 0 0-1.96 1.96v6.13a2 2 0 0 0 1.3 1.85V4.38a2.2 2.2 0 0 1 2.2-2.2"
        fill={color || "currentColor"}
      />
    </svg>
  );
}
